import { useEffect, useState } from "react";
import "./timer.sass";

const calculateTimeLeft = (targetDateTime) => {
  const difference = new Date(targetDateTime) - new Date();
  if (difference <= 0) return { hours: "00", minutes: "00", seconds: "00" };

  const hours = String(Math.floor(difference / (1000 * 60 * 60))).padStart(2, "0");
  const minutes = String(Math.floor((difference / (1000 * 60)) % 60)).padStart(2, "0");
  const seconds = String(Math.floor((difference / 1000) % 60)).padStart(2, "0");

  return { hours, minutes, seconds };
};

const timerStyleAddition = (minutes) => {
  minutes = parseInt(minutes)
  if (minutes > 15 && minutes <= 30) {
    return { backgroundColor: "yellow", borderRadius: "5px" }
  }
  if (minutes > 0 && minutes <= 15) {
    return { backgroundColor: "red", color: "white", borderRadius: "5px" }
  }
  return {}
}

export const Timer = ({ targetDateTime }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDateTime));
  const [prevTime, setPrevTime] = useState(timeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setPrevTime(timeLeft);
      setTimeLeft(calculateTimeLeft(targetDateTime));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDateTime, timeLeft]);


  return (
    <div style={timerStyleAddition(timeLeft.minutes)} className="timer">
      <Digits label={"hours"} current={timeLeft.hours} previous={prevTime.hours} />
      <span>:</span>
      <Digits label={"minutes"} current={timeLeft.minutes} previous={prevTime.minutes} />
      <span>:</span>
      <Digits label={"seconds"} current={timeLeft.seconds} previous={prevTime.seconds} />
    </div>
  );
};

const Digits = ({ current, previous, label }) => {
  const getDigits = () =>
    current.split("").map((digit, index) => {
      const prevDigit = previous[index];
      const isChanged = digit !== prevDigit;
      return (
        <div key={label + index}  className={`digit ${isChanged ? "animate" : ""}`}>
          {digit}
        </div>
      );
    });
  return <div className="digit-block">{getDigits()}</div>;
};
